import {Http} from './index.js'
import Resource from './resource-class'
// import {encodeQueryParams, buildUrlFilterParams} from '@/utils/api.js'

class ExtractAPI extends Resource {
  constructor () {
    super()
    this.resource = '/extract'
  }

  create (extracts) {
    /*
      Submits a list of extracts to the API.
    */
    const newExtracts = []
    extracts.forEach((e) => {
      const {extract, culture} = e
      const newExtract = {
        extract_extraction_method_id: extract.extraction_method ? extract.extraction_method.extract_extraction_method_id : undefined,
        extract_extraction_solvent_id: extract.extraction_solvent ? extract.extraction_solvent.extract_extraction_solvent_id : undefined,
        extraction_date: extract.extraction_date,
        researcher_id: culture.researcher.user_details_id,
        organization_id: culture.organization.organization_id,
        extraction_solvent_volume: parseFloat(extract.extraction_solvent_volume),
        comments: extract.comments
      }
      const payload = {
        extract: newExtract,
        culture_id: culture.culture_id
      }
      newExtracts.push(payload)
    })
    return Http.post(this.resource, newExtracts)
  }

  filename (extract) {
    /**
     * generate a sugested filename in the format
     * <initials>_YYYY-MM-DD_<e_id>__<metadata>.mzml
     */
    const researcher = extract.researcher
    const id = extract.extract_id
    let date = 'YYYY-MM-DD'
    if (extract.extraction_date && extract.extraction_date.includes('T')) {
      date = extract.extraction_date.split('T')[0]
    }
    let meta = ''
    let initials
    if (extract.culture && extract.culture.taxonomy && extract.culture.taxonomy.length) {
      const tax = extract.culture.taxonomy[0].tax
      meta = `${tax.genus || ''} ${tax.species || ''} ${tax.strain || ''}`
    }
    if (researcher.initials) {
      initials = researcher.initials
    } else if (researcher.first_name && researcher.last_name) {
      initials = `${researcher.first_name[0]}${researcher.last_name[0]}`
    } else {
      researcher.initials = `${researcher.first_name[0]}`
    }

    return `${initials}_${date}_${id}__${meta}.mzml`.replace(/\s/g, '_').replace(/[^a-zA-Z0-9-._]/g, '')
  }
}

export default new ExtractAPI()
